// shared/hooks/useAdminNavbar.js
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../../api/axios';

export const useAdminNavbar = (slug) => {
  const navigate = useNavigate();
  const [telefono, setTelefono] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [newTelefono, setNewTelefono] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Obtener número de teléfono
  const fetchTelefono = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/users/public/user/${slug}/phone`);
      setTelefono(response.data.telefono);
      setNewTelefono(response.data.telefono);
      setError(null);
    } catch (error) {
      console.error('Error al obtener el número de teléfono:', error);
      setError('No se pudo cargar el teléfono');
    } finally {
      setLoading(false);
    }
  };

  // Actualizar número de teléfono
  const handleSaveTelefono = async () => {
    if (newTelefono === telefono) {
      alert('El número de teléfono es el mismo');
      return;
    }

    try {
      const response = await api.put(`/users/public/user/${slug}/phone`, { 
        telefono: newTelefono 
      });

      if (response.status === 200) {
        setTelefono(newTelefono);
        setIsEditing(false);
        alert('Teléfono actualizado exitosamente');
        return true;
      }
    } catch (error) {
      console.error('Error al actualizar el teléfono:', error);
      alert('Error al actualizar el teléfono');
      return false;
    }
  };

  // Logout
  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  // Cargar teléfono al montar
  useEffect(() => {
    if (slug) {
      fetchTelefono();
    }
  }, [slug]);

  return {
    telefono,
    newTelefono,
    setNewTelefono,
    isEditing,
    setIsEditing,
    loading,
    error,
    handleSaveTelefono,
    handleLogout,
    fetchTelefono
  };
};